import Swal from 'sweetalert2';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
    providedIn: 'root'
})
export class LocalStorageService {

    setItem(key: string, value: any) {
        localStorage.setItem(key, JSON.stringify(value));
    }

    getItem(key: string) {
        try {
            let value = localStorage.getItem(key);
            if (!value) return null;

            return JSON.parse(value);
        } catch {
            return null;
        }
    }

    removeItem(key: string) {
        localStorage.removeItem(key);
    }

    clear() {
        localStorage.clear();
    }

    clearUser() {
        for (const key in localStorage) {
            if (key.startsWith('__USER__')) {
                localStorage.removeItem(key);
            }
        }
    }
}
